import _ from 'lodash';
import PropTypes from 'prop-types';

import ChannelFilter from './channel_filter';
import connect from 'components/lib/connect';
import { EndpointTypes } from 'models/endpoint';

const ChannelFilterContainer = connect(mapStateToProps)(ChannelFilter);

ChannelFilterContainer.propTypes = {
  onChange: PropTypes.func,
  queryId: PropTypes.string,
};

const NONE = [];

function mapStateToProps(context, props) {
  let result = context.getProvider('universalSearchResults').findBy({ id: props.queryId });
  let selectedChannels = _.get(result, 'query.filter.channels') || NONE;
  let channelConfiguration = context.getProvider('channelConfiguration').get();
  let isWhatsAppEnabled = !!channelConfiguration && channelConfiguration.isChannelEnabled(EndpointTypes.WHATSAPP);
  let isChatEnabled = !!channelConfiguration && channelConfiguration.isChannelEnabled(EndpointTypes.CHAT);
  let isTwitterEnabled = !!channelConfiguration && channelConfiguration.isChannelEnabled(EndpointTypes.TWITTER);
  let isInstagramDirectEnabled =
    !!channelConfiguration && channelConfiguration.isChannelEnabled(EndpointTypes.INSTAGRAM_DIRECT);

  return {
    fbMessengerEnabled: context.isFeatureEnabled('fbMessenger'),
    isChatEnabled,
    isInstagramDirectEnabled: isInstagramDirectEnabled && context.isFeatureEnabled('enableInstagramMessaging'),
    isWhatsAppEnabled,
    isTwitterEnabled,
    onChange: props.onChange,
    selectedChannels,
  };
}

export default ChannelFilterContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/search/filters/channel_filter_container.jsx